import { z } from "zod";
export const getPreferencesSchema = (t, options) => {
    return z.object({
        isOwner: options.displayOwnerFlag ? z.boolean() : z.boolean().optional(),
        shareSeekerProfile: z.boolean().optional(),
        shouldOptOutSavedSearch: z.boolean().optional(),
        offerOptin: z.boolean().optional(),
        newsletterOptout: z.boolean().optional(),
        newsletterOptInPreference: z
            .string()
            .min(1, { message: t("contact.form.opt_in_out_value_error_empty") })
            .optional(),
    });
};
